export const filterOptions = (distances: SelectOption[], items: SelectOption[]) => {};
